import { SxProps, Theme } from '@mui/material/styles';
import {
  REGISTRATION_TYPE_COLORS,
  RegistrationTypeEnum,
} from './registeredPharmacyPatients.helper';

const pharmacyColors = REGISTRATION_TYPE_COLORS[RegistrationTypeEnum.Pharmacy];
const registeredColors = REGISTRATION_TYPE_COLORS[RegistrationTypeEnum.Registered];

export const styles: Record<string, SxProps<Theme>> = {
  pageRoot: {
    width: '100%',
  },
  cardRoot: {
    width: '100%',
    position: 'relative',
  },
  headerBar: { display: 'flex', alignItems: 'center', px: 3, pt: 3, pb: 2 },
  title: { flex: 1, fontSize: 22, color: '#232323', fontWeight: 700 },
  searchWrap: { width: 260, display: 'flex', justifyContent: 'flex-end' },
  searchInput: {
    background: '#F7F7FA',
    borderRadius: 2,
    px: 2,
    py: 1.1,
    fontSize: 15,
    fontWeight: 500,
    color: '#232323',
    boxShadow: 'none',
    border: '1px solid #F0F0F0',
  },
  newPatientBtn: {
    ml: 2,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 14,
    borderRadius: 2,
    px: 3,
    py: 1,
    whiteSpace: 'nowrap',
    background: '#232323',
    color: '#fff',
    '&:hover': { background: '#444' },
  },
  viewToggleBar: {
    display: 'flex',
    alignItems: 'center',
    px: 3,
    pb: 1.5,
    gap: 1,
  },
  viewToggleLabel: {
    fontSize: 14,
    color: '#666',
    fontWeight: 500,
    mr: 0.5,
  },
  radioGroup: { gap: 0 },
  radioLabel: {
    '& .MuiFormControlLabel-label': {
      fontSize: 14,
      fontWeight: 500,
      color: '#232323',
    },
  },
  orangeRadio: {
    color: '#E87040',
    '&.Mui-checked': { color: '#E87040' },
  },
  pharmacyWalkInBadge: {
    backgroundColor: pharmacyColors.background,
    color: pharmacyColors.color,
    fontWeight: 600,
    fontSize: 12,
    borderRadius: '6px',
    border: `1px solid ${pharmacyColors.border}`,
    height: 26,
  },
  registeredBadge: {
    backgroundColor: registeredColors.background,
    color: registeredColors.color,
    fontWeight: 600,
    fontSize: 12,
    borderRadius: '6px',
    border: `1px solid ${registeredColors.border}`,
    height: 26,
  },
  tableContainer: { px: 3, background: '#fff', overflowX: 'auto' },
  scrollableTableContainer: {
    px: 3,
    background: '#fff',
    maxHeight: 'calc(100vh - 360px)',
    overflowY: 'auto',
    overflowX: 'auto',
    position: 'relative',
  },
  table: { minWidth: 600 },
  rowCell: { py: 1.5, fontSize: 14, color: '#232323', borderBottom: 'none' },
  interactiveRow: {
    borderBottom: '1px solid #F0F0F0',
    '&:last-child td': { borderBottom: 'none' },
    cursor: 'pointer',
    transition: 'background 0.2s',
    '&:hover': { background: '#F5F6FA' },
  },
  footerWrap: {
    px: 3,
    pb: 2,
    pt: 1.5,
    flexShrink: 0,
    borderTop: '1px solid #F0F0F0',
    background: '#fff',
  },
  footerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    mb: 1,
  },
  footerLeft: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  statusFilterBar: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },
  statusChipAll: {
    fontWeight: 600,
    fontSize: 12,
    cursor: 'pointer',
    borderRadius: '6px',
    height: 28,
  },
  statusChipPharmacy: {
    fontWeight: 600,
    fontSize: 12,
    cursor: 'pointer',
    borderRadius: '6px',
    height: 28,
    borderColor: pharmacyColors.border,
    color: pharmacyColors.color,
    backgroundColor: pharmacyColors.background,
    '&.MuiChip-outlined': {
      backgroundColor: 'transparent',
      color: pharmacyColors.color,
    },
  },
  statusChipRegistered: {
    fontWeight: 600,
    fontSize: 12,
    cursor: 'pointer',
    borderRadius: '6px',
    height: 28,
    borderColor: registeredColors.border,
    color: registeredColors.color,
    backgroundColor: registeredColors.background,
    '&.MuiChip-outlined': {
      backgroundColor: 'transparent',
      color: registeredColors.color,
    },
  },
  footerBar: { display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  footerText: { color: '#888', fontSize: 13, whiteSpace: 'nowrap' },
  pagination: { '& .MuiPaginationItem-root': { fontWeight: 500 } },
};


export const FilterIconSx={ width: '43px', height: '43px', cursor: 'pointer' };